<div class="grid" *ngIf="loadingData">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!loadingData">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="Nueva Conexión">
        <div class="grid">
          <div class="col-12">
            <form [formGroup]="formConfigUrl" (ngSubmit)="onSubmit()">
              <div class="grid form-group">
                <div class="col-4">
                  <div class="div-form">
                    <label>* {{ 'EXTENSIONESTELEFONICAS.LBL_CODIGO' | translate }}</label>
                    <input type="text" pInputText id="codigo"
                           name="codigo" formControlName="codigo"
                           maxlength="10" *ngIf="!editando"
                           upper-case-reactive
                            codigos-reactive>
                    <label *ngIf="editando" class="falso-combo-texto">{{configuracionUrl.codigo}}</label>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.codigo.valid">
                      {{ 'EXTENSIONESTELEFONICAS.LBL_CODIGO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="div-form">
                    <label>* {{ 'EXTENSIONESTELEFONICAS.LBL_NOMBRE' | translate }}</label>
                    <input type="text" pInputText id="nombre"
                           name="nombre" formControlName="nombre"
                           maxlength="100"
                           upper-case-reactive>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.nombre.valid">
                      {{ 'EXTENSIONESTELEFONICAS.LBL_NOMBRE' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="div-form" *ngIf="listaSistemas.length > 0">
                    <label>* {{ 'EXTENSIONESTELEFONICAS.LBL_SISTEMA' | translate }}</label>
                    <p-dropdown disableTab  id="idSistema" name="idSistema" [options]="listaSistemas"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="idSistema"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.idSistema.valid">
                      {{ 'EXTENSIONESTELEFONICAS.LBL_SISTEMA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid form-group">
                <div class="col-12">
                  <div class="div-form">
                    <label>* {{ 'EXTENSIONESTELEFONICAS.LBL_LINK' | translate }}</label>
                    <input type="text" pInputText id="link"
                           name="link" formControlName="link"
                           maxlength="255" (blur)="validarLink($event.target.value)">
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.link.valid">
                      {{ 'EXTENSIONESTELEFONICAS.LBL_LINK' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                    </div>
                    <div class="p-message p-messages-error p-corner-all" style="display: block;" *ngIf="linkConEspacios">
                      {{ 'EXTENSIONESTELEFONICAS.LBL_LINKCONESPACIOS' | translate }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid form-group">
                <div class="col-12">
                  <div class="div-form">
                    <label>* {{ 'EXTENSIONESTELEFONICAS.LBL_DESCRIPCION' | translate }}</label>
                    <textarea rows="3" cols="30" id="descripcion" name="descripcion" pInputTextarea
                              formControlName="descripcion"
                              class="falso-combo-texto"
                              maxlength="500"></textarea>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.descripcion.valid">
                      {{ 'EXTENSIONESTELEFONICAS.LBL_LINK' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid form-footer-buttons" *ngIf="!saving">
                <div class="form-group col-12">
                  <a (click)="regresarListado(formConfigUrl.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{tituloBoton | translate }}"
                          type="submit"
                          pButton></button>
                </div>
              </div>
              <div class="grid" *ngIf="saving">
                <div class="col-12 md:col-12 lg:col-12 text-center">
                  <i class="fa fa-refresh fa-spin fa-fw"></i>
                  <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
